/**
 * @file Recoilのセッションストレージ永続化ヘルパー
 *
 * Recoilのatomにセッションストレージ永続化を追加するためのeffect。
 * 画面遷移やリロード時にステートを維持する必要があるほとんどのステートで使用される。
 * ブラウザを閉じるとデータは破棄される（ローカルストレージ版はrecoillocalPersist.ts）。
 * ※サーバーサイドレンダリング時はwindowが存在しないためundefinedを設定する。
 */
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist({
  key: 'recoil-persist',
  storage: typeof window === 'undefined' ? undefined : sessionStorage,
});

export default persistAtom;
